import React, { Component } from "react";

import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel
} from "react-bootstrap";


import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import header_mobile from "../../assets/img/header-mobile.jpg";
import header_desktop from "../../assets/img/header-desktop.jpg";
import InputMask from 'react-input-mask';



const restLink_account = new HttpLink({ credentials: 'include', uri: "/api/v1/account/" });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});




const RESET_PASS = gql`
mutation  updatePassByToken($token: String!, $password: String!, $repassword: String!){
  updatePassByToken(token: $token, password:$password, repassword:$repassword) {
    id
    token
    error_login_msg
  }
}
`;


class ResetPassword extends Component {
  
  state = {
    password: null,
    repassword: null,
    msg: null,
    msg_type: "info"
  }

  reset_password = async () => {

    const user = (await account_client.mutate({
      variables: { token: this.props.match.params.token, password: this.state.password, repassword: this.state.repassword },
      mutation: RESET_PASS
    })).data.updatePassByToken;
    if (user.token !== null) {
      document.cookie = "token_user=" + user.token;// Grava o coookie
      this.setState({
        msg_type: "info",
        msg: "Senha alterada com sucesso, aguarde, você será redirecionado."
      });
      window.location.replace('/');
    } else {
      this.setState({
        msg_type: "warning",
        msg: user.error_login_msg
      });
    }
  }



  onChange_password = (event) => {
    this.setState({password: event.target.value});
  }
  onChange_repassword = (event) => {
      this.setState({repassword: event.target.value});
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.reset_password();
  }



  render() {

    var settings_banner = {
      autoplaySpeed: 5000,
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div>
        <img className="header_desktop" src={header_desktop} />
        <img className="header_mobile" src={header_mobile} />
      <div className="login-box">
              <div>
                {/* <div className="login-box-header login-box-header-color2"> <div className="login-box-text ">Recupere sua senha</div></div> */}
                <div className="login-box">

                <h1>Crie sua nova senha</h1>

                  <form
                    onSubmit={e => {
                      this.handleSubmit(e);
                      e.preventDefault();
                    }}
                  >
                    
                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_password,
                        name: "password",
                        label: "Senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Senha",
                        defaultValue: ""
                      }
                    ]}
                  /> 

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_repassword,
                        name: "password",
                        label: "Repetir senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Repetir senha",
                        defaultValue: ""
                      }
                    ]}
                  /> 
              
                    
                    <Row>
                      
                      <Col md={12}>
                        <Button bsStyle="info" fill type="submit">
                          Confirmar
                        </Button>
                      </Col>
                      
                      {
                        this.state.msg &&
                        <Col md={10}>
                          <Alert bsStyle={this.state.msg_type}>
                            {this.state.msg}
                          </Alert>
                        </Col>
                      }
                    </Row>
                  

                  </form>
                </div>
                
              </div>
            </div>


      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/views/Auth/NewPassword.jsx